import {FC} from "react";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const DeleteBroadcastModal: FC<{ broadcast: Broadcast, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const {showToast} = useToasts()

  const submit = async () => {
    await broadcasts.delete(props.broadcast.id).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het verwijderen.')
    })
    props.onFinished()
  }

  return <div>
    <div>Weet je zeker dat je de volgende publicatie wilt verwijderen?</div>
    <div className={'font-semibold'}>&middot; {props.broadcast.subject}</div>
    <ModalFooter text={'Verwijderen'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}